/* eslint-disable */
/* istanbul ignore file */
/* THIS FILE IS AUTOGENERATED - DO NOT EDIT */
import * as Types from '@shure/shared/angular/data-access/system-api/core';

import { gql } from 'apollo-angular';
import { Injectable } from '@angular/core';
import * as Apollo from 'apollo-angular';
export type DeviceAuthenticationFragment = {
	id: string;
	isDeviceNode: 'Device';
	features: {
		authentication: {
			credentials: Array<{ accessLevel: string; credentialsState: Types.CredentialsState }> | null;
		} | null;
	};
};

export type DeviceAuthenticationUpdateFragment = {
	id: string;
	features:
		| {
				authentication: {
					verifyCredentialsRequired: boolean | null;
					credentials: Array<{ accessLevel: string; credentialsState: Types.CredentialsState }> | null;
				} | null;
		  }
		| {};
};

export type DeviceAuthenticationSubscriptionVariables = Types.Exact<{
	id: Types.Scalars['ID']['input'];
	types: Array<Types.NodeChangeType> | Types.NodeChangeType;
}>;

export type DeviceAuthenticationSubscriptionOpResult = {
	nodeChanges: DeviceAuthenticationFragment | DeviceAuthenticationUpdateFragment | {};
};

export type AuthenticateMutationVariables = Types.Exact<{
	authenticateId: Types.Scalars['ID']['input'];
	keyring: Types.Scalars['String']['input'];
}>;

export type AuthenticateMutationOpResult = {
	authenticate: {
		device: { id: string; status: Types.DeviceStatus } | null;
		error: { code: Types.ErrorCode; message: string } | null;
	} | null;
};

export type BypassInitialCredentialsMutationVariables = Types.Exact<{
	bypassInitialCredentialInputs: Array<Types.BypassCredentialsInput> | Types.BypassCredentialsInput;
}>;

export type BypassInitialCredentialsMutationOpResult = {
	bypassInitialCredentials: Array<{
		device: { id: string } | null;
		error: { code: Types.ErrorCode; message: string } | null;
	}>;
};

export type CreateKeyringMutationVariables = Types.Exact<{
	createKeyringInput: Array<Types.KeyringInput> | Types.KeyringInput;
}>;

export type CreateKeyringMutationOpResult = {
	createKeyring: { keyring: string | null; error: { code: Types.ErrorCode; message: string } | null };
};

export type UpdateKeyringMutationVariables = Types.Exact<{
	currentKeyring: Types.Scalars['String']['input'];
	updateKeyringInput: Array<Types.KeyringInput> | Types.KeyringInput;
}>;

export type UpdateKeyringMutationOpResult = {
	updateKeyring: { keyring: string | null; error: { code: Types.ErrorCode; message: string } | null };
};

export type CreateCredentialsMutationVariables = Types.Exact<{
	createCredentialsInputs: Array<Types.CreateCredentialsInput> | Types.CreateCredentialsInput;
}>;

export type CreateCredentialsMutationOpResult = {
	createCredentials: Array<{
		device: { id: string } | null;
		error: { code: Types.ErrorCode; message: string } | null;
	}>;
};

export type RemoveCredentialsMutationVariables = Types.Exact<{
	removeCredentialsInputs: Array<Types.RemoveCredentialsInput> | Types.RemoveCredentialsInput;
	removeCredentialsKeyring: Types.Scalars['String']['input'];
}>;

export type RemoveCredentialsMutationOpResult = {
	removeCredentials: Array<{
		device: { id: string } | null;
		error: { code: Types.ErrorCode; message: string } | null;
	}>;
};

export type UpdateCredentialsMutationVariables = Types.Exact<{
	updateCredentialsInputs: Array<Types.UpdateCredentialsInput> | Types.UpdateCredentialsInput;
	updateCredentialsKeyring: Types.Scalars['String']['input'];
}>;

export type UpdateCredentialsMutationOpResult = {
	updateCredentials: Array<{
		device: { id: string } | null;
		error: { code: Types.ErrorCode; message: string } | null;
	}>;
};

export type VerifyCredentialsMutationVariables = Types.Exact<{
	verifyCredentialsInput: Array<Types.VerifyCredentialsInput> | Types.VerifyCredentialsInput;
}>;

export type VerifyCredentialsMutationOpResult = {
	verifyCredentials: Array<{
		device: { id: string } | null;
		error: { code: Types.ErrorCode; message: string } | null;
	}>;
};

export type ClearPasswordMutationVariables = Types.Exact<{
	deviceId: Types.Scalars['ID']['input'];
}>;

export type ClearPasswordMutationOpResult = {
	forceResetCredentials: { device: { id: string } | null; error: { code: Types.ErrorCode; message: string } | null };
};

export const DeviceAuthenticationFragment = gql`
	fragment DeviceAuthenticationFragment on Device {
		isDeviceNode: __typename
		id
		features {
			authentication {
				credentials {
					accessLevel
					credentialsState
				}
			}
		}
	}
`;
export const DeviceAuthenticationUpdateFragment = gql`
	fragment DeviceAuthenticationUpdateFragment on DeviceChange {
		id
		features {
			... on DeviceAuthenticationChange {
				authentication {
					credentials {
						accessLevel
						credentialsState
					}
					verifyCredentialsRequired
				}
			}
		}
	}
`;
export const DeviceAuthenticationSubscriptionDocument = gql`
	subscription DeviceAuthenticationSubscription($id: ID!, $types: [NodeChangeType!]!) {
		nodeChanges(id: $id, types: $types) {
			...DeviceAuthenticationFragment
			...DeviceAuthenticationUpdateFragment
		}
	}
	${DeviceAuthenticationFragment}
	${DeviceAuthenticationUpdateFragment}
`;

@Injectable({
	providedIn: 'root'
})
export class DeviceAuthenticationSubscriptionGQL extends Apollo.Subscription<
	DeviceAuthenticationSubscriptionOpResult,
	DeviceAuthenticationSubscriptionVariables
> {
	override document = DeviceAuthenticationSubscriptionDocument;
	override client = 'sysApi';
	constructor(apollo: Apollo.Apollo) {
		super(apollo);
	}
}
export const AuthenticateMutationDocument = gql`
	mutation AuthenticateMutation($authenticateId: ID!, $keyring: String!) {
		authenticate(id: $authenticateId, keyring: $keyring) {
			device {
				id
				status
			}
			error {
				code
				message
			}
		}
	}
`;

@Injectable({
	providedIn: 'root'
})
export class AuthenticateMutationGQL extends Apollo.Mutation<
	AuthenticateMutationOpResult,
	AuthenticateMutationVariables
> {
	override document = AuthenticateMutationDocument;
	override client = 'sysApi';
	constructor(apollo: Apollo.Apollo) {
		super(apollo);
	}
}
export const BypassInitialCredentialsMutationDocument = gql`
	mutation BypassInitialCredentialsMutation($bypassInitialCredentialInputs: [BypassCredentialsInput!]!) {
		bypassInitialCredentials(inputs: $bypassInitialCredentialInputs) {
			device {
				id
			}
			error {
				code
				message
			}
		}
	}
`;

@Injectable({
	providedIn: 'root'
})
export class BypassInitialCredentialsMutationGQL extends Apollo.Mutation<
	BypassInitialCredentialsMutationOpResult,
	BypassInitialCredentialsMutationVariables
> {
	override document = BypassInitialCredentialsMutationDocument;
	override client = 'sysApi';
	constructor(apollo: Apollo.Apollo) {
		super(apollo);
	}
}
export const CreateKeyringMutationDocument = gql`
	mutation CreateKeyringMutation($createKeyringInput: [KeyringInput!]!) {
		createKeyring(input: $createKeyringInput) {
			error {
				code
				message
			}
			keyring
		}
	}
`;

@Injectable({
	providedIn: 'root'
})
export class CreateKeyringMutationGQL extends Apollo.Mutation<
	CreateKeyringMutationOpResult,
	CreateKeyringMutationVariables
> {
	override document = CreateKeyringMutationDocument;
	override client = 'sysApi';
	constructor(apollo: Apollo.Apollo) {
		super(apollo);
	}
}
export const UpdateKeyringMutationDocument = gql`
	mutation UpdateKeyringMutation($currentKeyring: String!, $updateKeyringInput: [KeyringInput!]!) {
		updateKeyring(keyring: $currentKeyring, input: $updateKeyringInput) {
			error {
				code
				message
			}
			keyring
		}
	}
`;

@Injectable({
	providedIn: 'root'
})
export class UpdateKeyringMutationGQL extends Apollo.Mutation<
	UpdateKeyringMutationOpResult,
	UpdateKeyringMutationVariables
> {
	override document = UpdateKeyringMutationDocument;
	override client = 'sysApi';
	constructor(apollo: Apollo.Apollo) {
		super(apollo);
	}
}
export const CreateCredentialsMutationDocument = gql`
	mutation CreateCredentialsMutation($createCredentialsInputs: [CreateCredentialsInput!]!) {
		createCredentials(inputs: $createCredentialsInputs) {
			device {
				id
			}
			error {
				code
				message
			}
		}
	}
`;

@Injectable({
	providedIn: 'root'
})
export class CreateCredentialsMutationGQL extends Apollo.Mutation<
	CreateCredentialsMutationOpResult,
	CreateCredentialsMutationVariables
> {
	override document = CreateCredentialsMutationDocument;
	override client = 'sysApi';
	constructor(apollo: Apollo.Apollo) {
		super(apollo);
	}
}
export const RemoveCredentialsMutationDocument = gql`
	mutation RemoveCredentialsMutation(
		$removeCredentialsInputs: [RemoveCredentialsInput!]!
		$removeCredentialsKeyring: String!
	) {
		removeCredentials(inputs: $removeCredentialsInputs, keyring: $removeCredentialsKeyring) {
			device {
				id
			}
			error {
				code
				message
			}
		}
	}
`;

@Injectable({
	providedIn: 'root'
})
export class RemoveCredentialsMutationGQL extends Apollo.Mutation<
	RemoveCredentialsMutationOpResult,
	RemoveCredentialsMutationVariables
> {
	override document = RemoveCredentialsMutationDocument;
	override client = 'sysApi';
	constructor(apollo: Apollo.Apollo) {
		super(apollo);
	}
}
export const UpdateCredentialsMutationDocument = gql`
	mutation UpdateCredentialsMutation(
		$updateCredentialsInputs: [UpdateCredentialsInput!]!
		$updateCredentialsKeyring: String!
	) {
		updateCredentials(inputs: $updateCredentialsInputs, keyring: $updateCredentialsKeyring) {
			device {
				id
			}
			error {
				code
				message
			}
		}
	}
`;

@Injectable({
	providedIn: 'root'
})
export class UpdateCredentialsMutationGQL extends Apollo.Mutation<
	UpdateCredentialsMutationOpResult,
	UpdateCredentialsMutationVariables
> {
	override document = UpdateCredentialsMutationDocument;
	override client = 'sysApi';
	constructor(apollo: Apollo.Apollo) {
		super(apollo);
	}
}
export const VerifyCredentialsMutationDocument = gql`
	mutation VerifyCredentialsMutation($verifyCredentialsInput: [VerifyCredentialsInput!]!) {
		verifyCredentials(inputs: $verifyCredentialsInput) {
			device {
				id
			}
			error {
				code
				message
			}
		}
	}
`;

@Injectable({
	providedIn: 'root'
})
export class VerifyCredentialsMutationGQL extends Apollo.Mutation<
	VerifyCredentialsMutationOpResult,
	VerifyCredentialsMutationVariables
> {
	override document = VerifyCredentialsMutationDocument;
	override client = 'sysApi';
	constructor(apollo: Apollo.Apollo) {
		super(apollo);
	}
}
export const ClearPasswordMutationDocument = gql`
	mutation ClearPasswordMutation($deviceId: ID!) {
		forceResetCredentials(id: $deviceId) {
			device {
				id
			}
			error {
				code
				message
			}
		}
	}
`;

@Injectable({
	providedIn: 'root'
})
export class ClearPasswordMutationGQL extends Apollo.Mutation<
	ClearPasswordMutationOpResult,
	ClearPasswordMutationVariables
> {
	override document = ClearPasswordMutationDocument;
	override client = 'sysApi';
	constructor(apollo: Apollo.Apollo) {
		super(apollo);
	}
}
